// let url = 'https://mcinfor.kinghost.net:21006/'
// let url = 'https://gestaosaude.mcinfor-saude.net.br/'
let url = 'https://hmlgs.mcinfor-saude.net.br/'
if (process.env.NODE_ENV === 'production') {
  // url = 'https://mcinfor.kinghost.net:21006/'
  url = 'https://gestaosaude.mcinfor-saude.net.br/'
}

export default {
  api: {
    all: url,
    user: url
  }
}



// WEBPACK FOOTER //
// ./src/config.js